
import { MessageSquare, Clock, History, Check } from "lucide-react";
import { TimelineEvent } from "@/types/vehicleCard";

export const getEventIcon = (type: TimelineEvent['type']) => {
  switch (type) {
    case 'message':
      return <MessageSquare className="h-4 w-4 text-blue-600" />;
    case 'view':
      return <Clock className="h-4 w-4 text-blue-600" />;
    case 'change':
      return <History className="h-4 w-4 text-purple-600" />;
    case 'status':
      return <Check className="h-4 w-4 text-purple-600" />;
    default:
      return <Clock className="h-4 w-4" />;
  }
};

